var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("tabs -" + (this.type))},[_c('tab-nav',{attrs:{"panes":_vm.panesProps,"active-key":_vm.priCurrentKey,"width":_vm.width,"gap":_vm.gap},on:{"active-change":_vm.handleUpdate}}),_vm._v(" "),_c('div',{staticClass:"tabs-content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc5eb410","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tabs/Tabs.vue
// module id = null
// module chunks = 